import {target, getParent} from '../utils/dom';

const className = 'active';
const eventActive = new CustomEvent('activate', {bubbles: true});
const eventDeactive = new CustomEvent('deactivate', {bubbles: true});

document.addEventListener('click', click);

function click(event) {
	let trigger = target(event.target, '[data-activable-trigger]');
	let el;
	if (trigger) {
		el = getParent(trigger, '[data-activable]');
	} else {
		trigger = target(event.target, '[data-activable]');
		if (!trigger || trigger.query('[data-activable-trigger]')) {
			return;
		}
		el = trigger;
	}
	el.classList.toggle(className);
	if (el.classList.contains(className)) {
		el.dispatchEvent(eventActive);
	} else {
		el.dispatchEvent(eventDeactive);
	}
}
